import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './icons-bar.css';

class IconsBar extends Component {
  render() {
    let imgClass = this.props.isCircles ? 'circle' : '';
    imgClass += ' regular-grow-animation';

    const listItems = this.props.iconsData.map((data) => 
      <li key={data.title}>
        <a href={data.link} title={data.title} target='_blank'>
          <img src={data.imgSrc} alt={data.title} className={imgClass}/>
        </a>
      </li>
    );

    return (
      <ul className='icons-bar'>
        {listItems}
      </ul>
    );
  }
}

IconsBar.propTypes = {
  iconsData: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,    
    link: PropTypes.string.isRequired,
    imgSrc: PropTypes.any.isRequired
  })).isRequired,
  
  isCircles: PropTypes.bool
};

IconsBar.defaultProps = {
  isCircles: false
};

export default IconsBar;